export const RECEIVE_FINANCIAL_TRUSTPASS = "RECEIVE_FINANCIAL_TRUSTPASS";
export const UPDATE_FINANCIAL_TRUSTPASS_DOCUMENT = "UPDATE_FINANCIAL_TRUSTPASS_DOCUMENT";
export const RECEIVE_FINANCIAL_TRUSTPASS_DOCUMENT = "RECEIVE_FINANCIAL_TRUSTPASS_DOCUMENT";

export const FINANCIAL_TRUSTPASS_HYDRATE = "FINANCIAL_TRUSTPASS_HYDRATE";
export const CREDIT_BOOST_UPDATE = "CREDIT_BOOST_UPDATE";



// WEBPACK FOOTER //
// ./src/features/financial-trustpass/actionTypes.js